import classNames from "classnames";
import styles from "./AscTextArea.module.scss";

type AscTextTextAreaSize = "small" | "medium" | "large";

export interface AscTextTextAreaProps
  extends Omit<
    React.DetailedHTMLProps<
      React.TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >,
    "size"
  > {
  size?: AscTextTextAreaSize;
  className?: string;
  fullWidth?: boolean;
}

export default function AscTextTextArea({
  size = "medium",
  className,
  fullWidth = false,
  ...rest
}: AscTextTextAreaProps) {
  return (
    <textarea
      className={classNames(
        styles.ground,
        {
          [styles.large]: size === "large",
          [styles.medium]: size === "medium",
          [styles.small]: size === "small",
          [styles.fullWidth]: fullWidth,
        },

        className
      )}
      {...rest}
    />
  );
}
